import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10f3e72a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = { class: "inputs" }

import { inject, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Input from '@/components/Input.vue'
import {
    activateLogin,
    updatePassword,
    getPasswordPolicy,
} from '@/mobile/src/api/auth'
import TransparentButton from '@/mobile/src/components/TransparentButton.vue'
import { loginAndRedirect, parseDeepLinkUrl } from '@/mobile/src/services/auth'
import { LoginMainPkey, LoginMainProvided } from '@/mobile/src/types/auth'

interface Props {
    url: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Activation',
  props: {
    url: { default: '' }
  },
  setup(__props: any) {

const props = __props

const domain = ref('')
const token = ref('')
const query = ref<any>({})
const password = ref('')
const phone = ref('')
const method = ref('')
const requirePhone = ref(false)

const router = useRouter()

const { persistCredentials } = inject(LoginMainPkey) as LoginMainProvided

onMounted(async () => {
    const parsedUrl = parseDeepLinkUrl(props.url)
    domain.value = parsedUrl.domain
    token.value = parsedUrl.token
    query.value = parsedUrl.query
    method.value =
        query.value && query.value.method ? query.value.method.toString() : ''

    const { success, data, msg } = await getPasswordPolicy(
        domain.value,
        token.value
    )
    if (success) {
        requirePhone.value = data.requirePhone
        phone.value = data.phone
    } else {
        alert(msg)
        await router.replace({ name: 'findlogin' })
    }
})

function onUpdatePassword(newPass: string) {
    password.value = newPass
}

function onUpdatePhone(newPhone: string) {
    phone.value = newPhone
}

async function activateAccount() {
    if (requirePhone.value) {
        if (!phone.value) {
            alert('Mobile number is required')
            return
        }
    }

    if (requirePhone.value) {
        await activate()
    } else {
        await setPassword()
    }
}

async function setPassword() {
    const { success, data, msg } = await updatePassword(
        domain.value,
        token.value,
        password.value
    )
    if (success) {
        persistCredentials({ email: data.email, password: password.value })
        await loginAndRedirect(domain.value, data.email, password.value)
    } else {
        alert(msg)
    }
}

async function activate() {
    const { success, data, msg } = await activateLogin(
        domain.value,
        token.value,
        password.value,
        phone.value,
        method.value
    )
    if (success) {
        persistCredentials({ email: data.email, password: password.value })
        await loginAndRedirect(domain.value, data.email, password.value)
    } else {
        alert(msg)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Input, {
        title: "Password",
        placeholder: "Password",
        type: "password",
        required: true,
        "err-msg": 'Invalid Password',
        "model-value": password.value,
        "onUpdate:modelValue": onUpdatePassword
      }, null, 8, ["model-value"]),
      (method.value !== 'phone' && requirePhone.value)
        ? (_openBlock(), _createBlock(Input, {
            key: 0,
            title: "Phone",
            placeholder: "Phone",
            type: "text",
            required: true,
            "err-msg": 'Invalid Number',
            "model-value": phone.value,
            "onUpdate:modelValue": onUpdatePhone
          }, null, 8, ["model-value"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(TransparentButton, {
      id: "btnActivate",
      class: "btn-login",
      text: "Activate",
      click: activateAccount
    })
  ]))
}
}

})